import { render, staticRenderFns } from "./TerapieComplicanzeView.vue?vue&type=template&id=2303f56e"
import script from "./TerapieComplicanzeView.vue?vue&type=script&lang=js"
export * from "./TerapieComplicanzeView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports